import React from 'react';
import { Link } from 'react-router-dom';
import { FaStar } from 'react-icons/fa';

function ProductCard({ product }) {
  return (
    <div className="product-card">
      <Link to={`/product/${product.id}`}>
        <div className="product-image-wrapper">
          <img src={product.image} alt={product.name} className="product-image" />
          <span className="product-badge">Νέο</span>
        </div>
        <div className="product-info">
          <h3 className="product-title">{product.name}</h3>
          <p className="product-description">{product.shortDescription}</p>
          
          <div className="product-rating">
            <div className="stars">
              {[1, 2, 3, 4, 5].map(star => (
                <FaStar key={star} className="star-icon" />
              ))}
            </div>
            <span className="rating-text">(5.0)</span>
          </div>
          
          <p className="product-price">€{product.price.toFixed(2)}</p>
          
          <div className="product-actions">
            <button className="btn btn-primary">Προβολή Λεπτομερειών</button>
          </div>
        </div>
      </Link>
    </div>
  );
}

export default ProductCard;